import React from 'react';
import cn from 'clsx';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import {
  AngleLeftLightIcon,
  AngleRightLightIcon
} from '../../shared/icons/icons';

import { ChildrenProp } from '../../shared/utils/prop-types/prop-types';

import styles from './date-toggle.scss';

function DateToggle(props) {
  const {
    children,
    className,
    dates,
    defaultDate = format(new Date(), 'MM/DD/YYYY'),
    onSelectDate,
    selectedDate
  } = props;

  if (!Array.isArray(dates)) {
    return null;
  }

  const myDate = selectedDate || defaultDate;
  const currentIndex = getCurrentDateIndex(myDate);
  const dayOfWeek = format(myDate || '', 'dddd');
  const formattedDate = format(myDate || '', 'MMMM Do');
  const showPrev = currentIndex > 0;
  const showNext = currentIndex < dates.length - 1;

  function getCurrentDateIndex(selectedDate) {
    return dates.findIndex(date => date === selectedDate);
  }

  return (
    <div className={cn(styles['container'], className)}>
      <button
        aria-label="Previous Date"
        className={showPrev ? styles['toggle'] : styles['invisible']}
        data-testid={'prevButton'}
        disabled={!showPrev}
        onClick={() => onSelectDate(dates[currentIndex - 1])}
        type="button"
      >
        <AngleLeftLightIcon />
      </button>
      <span className={styles['current-date']}>
        <strong>
          {dayOfWeek}, {formattedDate}
        </strong>
      </span>

      <button
        aria-label="Next Date"
        className={showNext ? styles['toggle'] : styles['invisible']}
        data-testid={'nextButton'}
        disabled={!showNext}
        onClick={() => onSelectDate(dates[currentIndex + 1])}
        type="button"
      >
        <AngleRightLightIcon />
      </button>

      {children}
    </div>
  );
}

DateToggle.propTypes = {
  children: ChildrenProp,
  className: PropTypes.string,
  dates: PropTypes.array.isRequired,
  defaultDate: PropTypes.string,
  onSelectDate: PropTypes.func,
  selectedDate: PropTypes.string
};

export default DateToggle;
